<sc-flex vertical fitHeight stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label
      dictionaryKey="tmc-common.gate-keeping.ui.gate-keeper-control.dialog-select-qr-camera-title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-flex-fitting-content vertical>
    <sc-no-data-container [hasData]="availableCameras?.length > 0" fitHeight>
      <sc-scroll-pane>
        <sc-padding>
          <sc-flex vertical stretchContent [gap]="16">
            <sc-selectable-tile *ngFor="let camera of availableCameras" (click)="selectCamera(camera)"
              [style]="camera === selectedCamera ? 'selected' : 'default'">
              <sc-padding>
                {{ camera.label }}
              </sc-padding>
            </sc-selectable-tile>
          </sc-flex>
        </sc-padding>
      </sc-scroll-pane>
    </sc-no-data-container>
  </sc-flex-fitting-content>

  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="close()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary (click)="confirm()" [disabled]="selectedCamera == null"></sc-confirm-button>
    </sc-flex>
  </sc-padding>

</sc-flex>